import { formatStartEndDateTime } from 'src/utils/formatDate';

import ArticleHero from 'components/BaseHelpers/ArticleHero';

import { ComponentProps } from '../../../types/component-props';
import { CoreEventHeroData } from '../../../types/components';

export type CoreEventHeroProps = ComponentProps & CoreEventHeroData;

const CoreEventHero = (props: CoreEventHeroProps): JSX.Element => {
  const {
    breadcrumbs,
    contentTag,
    image,
    offices,
    startDateTime,
    endDateTime,
    displayDate,
    showTimeOfDay,
    title,
  } = props.fields;

  const formattedDate = formatStartEndDateTime(startDateTime, endDateTime, displayDate);

  return (
    <ArticleHero
      breadcrumbs={breadcrumbs}
      eyebrow={contentTag}
      image={image}
      links={offices}
      title={title}
      subhead={showTimeOfDay ? formattedDate.display : formattedDate.dateOnlyDisplay}
    />
  );
};

export default CoreEventHero;
